import { gql, TypedDocumentNode } from 'apollo-angular';

import {
  IPageOfPropertyInput,
  IPageOfPropertyData,
  IGetValidPropertyInput,
  IGetValidPropertyData,
  IAllSourceReferAPropertyUrlsInput,
  IAllSourceReferAPropertyUrlsData,
} from '@shared/models/properties';

export const PROPERTY_LIST_FRAGMENT = gql`
  fragment PropertyListFragment on Property {
    id
    price
    status
    isFavorite @include(if: $isLoggedIn)
    description @include(if: $isLoggedIn)
    repairs @include(if: $isLoggedIn)
    images {
      uuid
      thumbnail {
        url
      }
      small {
        url
      }
    }

    street @include(if: $isLoggedIn)
    houseNumber @include(if: $isLoggedIn)
    city
    state
    zip
    latitude @include(if: $isLoggedIn)
    longitude @include(if: $isLoggedIn)

    bedrooms @include(if: $isLoggedIn)
    bathrooms @include(if: $isLoggedIn)
    squareFoot @include(if: $isLoggedIn)
    type
    subType
    yearBuilt

    organization {
      id
      name
      shortName
    }

    offMarket {
      agentName
      agentPhoneNumber
      companyName
      companyPhoneNumber
    }

    dispositionAgent {
      normalizedFullName
      phoneNumber
    }

    # proForma {
    # capitalizationRate
    # grossYield
    # projectRoi
    # }

    insertedAt
  }
`;

const PROPERTY_FRAGMENT = gql`
  ${PROPERTY_LIST_FRAGMENT}
  fragment PropertyFragment on Property {
    ...PropertyListFragment
    images {
      uuid
      thumbnail {
        url
      }
      small {
        url
      }
      medium {
        url
      }
      large {
        url
      }
    }

    lotSize @include(if: $isLoggedIn)
    yearBuilt @include(if: $isLoggedIn)

    cmaUrl @include(if: $isLoggedIn)

    showing @include(if: $isLoggedIn) {
      floorPlanUrl
      inspectionUrl
      showDate
      originalShowDate
      timezone
      tourThreeDUrl
    }

    dealInfo {
      contractType
      renovationCostEstimate
      closeEscrowDate
      earnestMoneyDeposit
      occupancyType
      isDeliverVacant
      postOccupancyDays
      remainingLeaseMonths
      monthlyRent
      arv
    }

    viewCount
  }
`;

export const FETCH_PROPERTIES: TypedDocumentNode<
  IPageOfPropertyData,
  IPageOfPropertyInput
> = gql`
  ${PROPERTY_LIST_FRAGMENT}
  query listValidProperties(
    $organizationId: ID
    $filter: PropertyFilterInput
    $limit: Int
    $offset: Int
    $sort: [PropertySortInput]
    $isLoggedIn: Boolean!
  ) {
    listValidProperties(
      organizationId: $organizationId
      filter: $filter
      limit: $limit
      offset: $offset
      sort: $sort
    ) {
      count
      results {
        ...PropertyListFragment
      }
    }
  }
`;

export const FETCH_PROPERTY: TypedDocumentNode<
  IGetValidPropertyData,
  IGetValidPropertyInput
> = gql`
  ${PROPERTY_FRAGMENT}
  query getValidProperty(
    $id: ID!
    $organizationId: ID
    $isLoggedIn: Boolean!
    $refCode: String
    $campaignName: String
    $entityId: ID
  ) {
    getValidProperty(
      id: $id
      organizationId: $organizationId
      refCode: $refCode
      campaignName: $campaignName
      entityId: $entityId
    ) {
      ...PropertyFragment
    }
  }
`;

export const ALL_SOURCE_REFER_A_PROPERTY_URLS: TypedDocumentNode<
  IAllSourceReferAPropertyUrlsData,
  IAllSourceReferAPropertyUrlsInput
> = gql`
  query allSourceReferAPropertyUrls(
    $propertyId: ID!
    $shortName: String
    $type: String
  ) {
    allSourceReferAPropertyUrls(
      propertyId: $propertyId
      shortName: $shortName
      type: $type
    )
  }
`;
